import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SupplyProduct from '@mui/icons-material/LocalShipping';
import AddSRV from '@mui/icons-material/PostAdd';
import Assessment from '@mui/icons-material/Assessment';
import AddTaskIcon from '@mui/icons-material/AddTask';
import MessageIcon from '@mui/icons-material/Message';
import TelegramIcon from '@mui/icons-material/Telegram';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import SchoolIcon from '@mui/icons-material/School';
import StartIcon from '@mui/icons-material/Start';
import MoneyIcon from '@mui/icons-material/Money';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PeopleIcon from '@mui/icons-material/People';
import { useSelector } from 'react-redux';

export default function AccountMenu(props) {
    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const admin = useSelector((state) => state.admin) || {};
    const isTeacher = ["Class Teacher", "Class and Subject Teacher", "Subject Teacher"].includes(admin.positiondescription);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="More Options">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Tooltip>
            </Box>


            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                       
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
  {isTeacher ? (
    <>
      <MenuItem onClick={() => props.preparereport(props.data)}>
        <ListItemIcon>
          <Assessment fontSize="small" />
        </ListItemIcon>
        Prepare Academic Report
      </MenuItem>
      <MenuItem onClick={() => props.bulkreport(props.data)}>
        <ListItemIcon>
          <LocalPrintshopIcon fontSize="small" />
        </ListItemIcon>
        Print Academic Report
      </MenuItem>
      <MenuItem onClick={() => props.sendbulkreport(props.data)}>
        <ListItemIcon>
          <TelegramIcon fontSize="small" />
        </ListItemIcon>
        Send Bulk Academic Report
      </MenuItem>
      {typeof props.classlist === 'function' ? (
        <MenuItem onClick={() => props.classlist(props.data)}>
          <ListItemIcon>
            <PeopleIcon fontSize="small" />
          </ListItemIcon>
          Class student list
        </MenuItem>
      ) : null}
    </>
  ) : (
    <>
  <MenuItem onClick={() => props.preparereport(props.data)}>
                    <ListItemIcon>
                        <Assessment fontSize="small" />
                    </ListItemIcon>
                    Prepare Academic Report
                </MenuItem>
                <MenuItem onClick={() => props.preparebill(props.data)}>
                    <ListItemIcon>
                        <ReceiptIcon fontSize="small" />
                    </ListItemIcon>
                    Prepare Class Bill
                </MenuItem>
                <MenuItem onClick={() => props.classinfo(props.data)}>
                    <ListItemIcon>
                    <VisibilityIcon fontSize="small" />

                    </ListItemIcon>
                   Class Information
                </MenuItem>
                {typeof props.classlist === 'function' ? (
                    <MenuItem onClick={() => props.classlist(props.data)}>
                        <ListItemIcon>
                            <PeopleIcon fontSize="small" />
                        </ListItemIcon>
                        Class student list
                    </MenuItem>
                ) : null}
                <MenuItem onClick={() => props.nextclass(props.data)}>
                    <ListItemIcon>
                    <StartIcon fontSize="small" />

                    </ListItemIcon>
                   Set Next Class
                </MenuItem>
                

                <MenuItem onClick={() => props.viewatt(props.data)}>
                    <ListItemIcon>
                        <EventAvailableIcon fontSize="small" />
                    </ListItemIcon>
                    View Attendance
                </MenuItem>

                <MenuItem onClick={() => props.message(props.data)}>
                    <ListItemIcon>
                    <MessageIcon fontSize="small" />

                    </ListItemIcon>
                   Send Message to Guardian
                </MenuItem>
 
                <MenuItem onClick={() => props.academics(props.data)}>
                    <ListItemIcon>
                        <SchoolIcon fontSize="small" />
                    </ListItemIcon>
                    Academic Records
                </MenuItem>
                <MenuItem onClick={() => props.sendbulkreport(props.data)}>
                    <ListItemIcon>
                        <TelegramIcon fontSize="small" />
                    </ListItemIcon>
                    Send Bulk Academic Report
                </MenuItem>   
                <MenuItem onClick={() => props.sendbulkreportpdf(props.data)}>
                    <ListItemIcon>
                        <PictureAsPdfIcon fontSize="small" />
                    </ListItemIcon>
                    Send Bulk Academic Report as PDF
                </MenuItem>                <MenuItem onClick={() => props.bulkreport(props.data)}>
                    <ListItemIcon>
                        <LocalPrintshopIcon fontSize="small" />
                    </ListItemIcon>
                    Print Bulk Academic Report
                </MenuItem> 
                <MenuItem onClick={() => props.bulkbill(props.data)}>
                    <ListItemIcon>
                        <AttachMoneyIcon fontSize="small" />
                    </ListItemIcon>
                    Print Bulk Student Bill
                </MenuItem>
                <MenuItem onClick={() => props.viewbill(props.data)}>
                    <ListItemIcon>
                        <MonetizationOnIcon fontSize="small" />
                    </ListItemIcon>
                    View Class Bill
                </MenuItem>
              

                <Divider/>
                <MenuItem onClick={() => props.edit(props.data)}>
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    Edit
                </MenuItem>
                <MenuItem onClick={() => props.delete(props.data)}>
                    <ListItemIcon>
                        <DeleteIcon fontSize="small" />
                    </ListItemIcon>
                    Delete
                </MenuItem>
                </>
              )}
            </Menu>


        </React.Fragment>

    );
}

